import React from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../css/HomeLayout.css';
import { useUser } from './userContext';
import { authAPI } from '../api/apiClient';
import { FaArrowLeft, FaPowerOff } from 'react-icons/fa';

const HomeLayout = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { guid: tripGuid } = useParams(); 
  const handleLogout = async () => {
    try {
      await authAPI.logout();
      setUser(null);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
      alert('Nie udało się wylogować. Spróbuj ponownie.');
    }
  };

  const handleGoBack = () => {
    const isRootTripPage = location.pathname === `/trips/${tripGuid}`;
  
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else if (isRootTripPage) {
      navigate('/', { replace: true });
    } else if (tripGuid) {
      navigate(`/trips/${tripGuid}`, { replace: true });
    } else {
      navigate('/');
    }
  };


  const isOnHome = location.pathname === '/';
  const userInitial = user?.name?.trim()?.charAt(0)?.toUpperCase() || '?';
  return (
    <div className="layout-container">
      <header className={`banner sticky-banner ${process.env.REACT_APP_ENV === 'test' ? 'banner--test' : ''}`}>
        {process.env.REACT_APP_ENV === 'test' && (
          <div className="env-label">TEST</div>
        )}
      {!isOnHome && (
          <button className="back-nav" onClick={handleGoBack}>
            <FaArrowLeft />
          </button>
        )}
        <div className="banner-right">
          <div className="user-info">
          {user?.picture ? (
              <img src={user.picture} alt="User Avatar" className="user-avatar" />
            ) : (
              <div className="user-avatar-initial user-avatar">{userInitial}</div>
            )}

            <div>
              <p className="user-name">{user?.name || 'Gość'}</p>
            </div>
          </div>

          <div className="logout-icon" onClick={handleLogout} title="Wyloguj się">
            <FaPowerOff />
          </div>
        </div>
      </header>

      <main className="layout-content">
        <Outlet />
      </main>
    </div>
  );
};

export default HomeLayout;
